import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useDialectSdk, useDialectWallet } from '@dialectlabs/react-sdk';
import NotAuthorizedError from '../errors/ui/NotAuthorizedError';
import NoWalletError from '../errors/ui/NoWalletError';
import EncryptionInfo from '../wallet-states/EncryptionInfo';
import SignMessageInfo from '../wallet-states/SignMessageInfo';
import SignTransactionInfo from '../wallet-states/SignTransactionInfo';
function WalletStatesWrapper({ header = null, notConnectedMessage, children, }) {
    const sdk = useDialectSdk(true);
    const { walletConnected: { get: isWalletConnected }, connectionInitiatedState: { get: isConnectionInitiated, set: setConnectionInitiated, }, isSigningMessageState: { get: isSigningMessage }, isSigningFreeTransactionState: { get: isSigningFreeTransaction }, isEncryptingState: { get: isEncrypting }, } = useDialectWallet();
    if (typeof children === 'function') {
        return children({
            isSigningMessage: isSigningMessage,
            isEncrypting: isEncrypting,
            isConnectionInitiated: isConnectionInitiated,
            setConnectionInitiated,
        });
    }
    if (!isWalletConnected || (!sdk && isConnectionInitiated)) {
        return (_jsxs(_Fragment, { children: [header, _jsx(NoWalletError, { message: notConnectedMessage })] }));
    }
    if (!isConnectionInitiated) {
        return (_jsxs(_Fragment, { children: [header, _jsx(NotAuthorizedError, {})] }));
    }
    if (isSigningMessage) {
        return (_jsxs(_Fragment, { children: [header, _jsx(SignMessageInfo, {})] }));
    }
    if (isSigningFreeTransaction) {
        return (_jsxs(_Fragment, { children: [header, _jsx(SignTransactionInfo, {})] }));
    }
    if (isEncrypting) {
        return (_jsxs(_Fragment, { children: [header, _jsx(EncryptionInfo, {})] }));
    }
    return children;
}
export default WalletStatesWrapper;
//# sourceMappingURL=WalletStatesWrapper.js.map